const unidecodeSymbols = [
    ["ā","a"],["ē","e"],["ī","i"],["ō","o"],["ū","u"],
    ["ă","a"],["ĕ","e"],["ĭ","i"],["ŏ","o"],["ŭ","u"],
    ["Ā","A"],["Ē","E"],["Ī","I"],["Ō","O"],["Ū","U"],
    ["Ă","A"],["Ĕ","E"],["Ĭ","I"],["Ŏ","O"],["Ŭ","U"],
    ["ἀ","α"],["ἁ","α"],["ἂ","α"],["ἃ","α"],["ἄ","α"],
    ["ἅ","α"],["ἆ","α"],["ἇ","α"],["Ἀ","Α"],["Ἁ","Α"],
    ["Ἂ","Α"],["Ἃ","Α"],["Ἄ","Α"],["Ἅ","Α"],["Ἆ","Α"],
    ["Ἇ","Α"],["ἐ","ε"],["ἑ","ε"],["ἒ","ε"],["ἓ","ε"],
    ["ἔ","ε"],["ἕ","ε"],["Ἐ","Ε"],["Ἑ","Ε"],["Ἒ","Ε"],
    ["Ἓ","Ε"],["Ἔ","Ε"],["Ἕ","Ε"],["ἠ","η"],["ἡ","η"],
    ["ἢ","η"],["ἣ","η"],["ἤ","η"],["ἥ","η"],["ἦ","η"],
    ["ἧ","η"],["Ἠ","Η"],["Ἡ","Η"],["Ἢ","Η"],["Ἣ","Η"],
    ["Ἤ","Η"],["Ἥ","Η"],["Ἦ","Η"],["Ἧ","Η"],["ἰ","ι"],
    ["ἱ","ι"],["ἲ","ι"],["ἳ","ι"],["ἴ","ι"],["ἵ","ι"],
    ["ἶ","ι"],["ἷ","ι"],["Ἰ","Ι"],["Ἱ","Ι"],["Ἲ","Ι"],
    ["Ἳ","Ι"],["Ἴ","Ι"],["Ἵ","Ι"],["Ἶ","Ι"],["Ἷ","Ι"],
    ["ὀ","ο"],["ὁ","ο"],["ὂ","ο"],["ὃ","ο"],["ὄ","ο"],
    ["ὅ","ο"],["Ὀ","Ο"],["Ὁ","Ο"],["Ὂ","Ο"],["Ὃ","Ο"],
    ["Ὄ","Ο"],["Ὅ","Ο"],["ὐ","υ"],["ὑ","υ"],["ὒ","υ"],
    ["ὓ","υ"],["ὔ","υ"],["ὕ","υ"],["ὖ","υ"],["ὗ","υ"],
    ["Ὑ","Υ"],["Ὓ","Υ"],["Ὕ","Υ"],["Ὗ","Υ"],["ὠ","ω"],
    ["ὡ","ω"],["ὢ","ω"],["ὣ","ω"],["ὤ","ω"],["ὥ","ω"],
    ["ὦ","ω"],["ὧ","ω"],["Ὠ","Ω"],["Ὡ","Ω"],["Ὢ","Ω"],
    ["Ὣ","Ω"],["Ὤ","Ω"],["Ὥ","Ω"],["Ὦ","Ω"],["Ὧ","Ω"],
    ["ὰ","α"],["ά","α"],["ὲ","ε"],["έ","ε"],["ὴ","η"],
    ["ή","η"],["ὶ","ι"],["ί","ι"],["ὸ","ο"],["ό","ο"],
    ["ὺ","υ"],["ύ","υ"],["ὼ","ω"],["ώ","ω"],["ᾀ","α"],
    ["ᾁ","α"],["ᾂ","α"],["ᾃ","α"],["ᾄ","α"],["ᾅ","α"],
    ["ᾆ","α"],["ᾇ","α"],["ἈΙ","Α"],["ἉΙ","Α"],["ἊΙ","Α"],
    ["ἋΙ","Α"],["ἌΙ","Α"],["ἍΙ","Α"],["ἎΙ","Α"],["ἏΙ","Α"],
    ["ᾐ","η"],["ᾑ","η"],["ᾒ","η"],["ᾓ","η"],["ᾔ","η"],
    ["ᾕ","η"],["ᾖ","η"],["ᾗ","η"],["ἨΙ","Η"],["ἩΙ","Η"],
    ["ἪΙ","Η"],["ἫΙ","Η"],["ἬΙ","Η"],["ἭΙ","Η"],["ἮΙ","Η"],
    ["ἯΙ","Η"],["ᾠ","ω"],["ᾡ","ω"],["ᾢ","ω"],["ᾣ","ω"],
    ["ᾤ","ω"],["ᾥ","ω"],["ᾦ","ω"],["ᾧ","ω"],["ὨΙ","Ω"],
    ["ὩΙ","Ω"],["ὪΙ","Ω"],["ὫΙ","Ω"],["ὬΙ","Ω"],["ὭΙ","Ω"],
    ["ὮΙ","Ω"],["ὯΙ","Ω"],["ᾰ","α"],["ᾱ","α"],["ᾲ","α"],
    ["ᾳ","α"],["ᾴ","α"],["ᾶ","α"],["ᾷ","α"],["Ᾰ","Α"],
    ["Ᾱ","Α"],["Ὰ","Α"],["Ά","Α"],["ΑΙ","Α"],["᾽",""],
    ["᾿",""],["῀",""],["῁",""],["ῂ","η"],
    ["ῃ","η"],["ῄ","η"],["ῆ","η"],["ῇ","η"],["Ὲ","Ε"],
    ["Έ","Ε"],["Ὴ","Η"],["Ή","Η"],["ΗΙ","Η"],["῍",""],
    ["῎",""],["῏",""],["ῐ","ι"],["ῑ","ι"],["ῒ","ι"],
    ["ΐ","ι"],["ῖ","ι"],["ῗ","ι"],["Ῐ","ι"],["Ῑ","ι"],
    ["Ὶ","Ι"],["Ί","Ι"],["῝",""],["῞",""],["῟",""],
    ["ῠ","υ"],["ῡ","υ"],["ῢ","υ"],["ΰ","υ"],["ῤ","ρ"],
    ["ῥ","ρ"],["ῦ","υ"],["ῧ","υ"],["Ῠ","Υ"],["Ῡ","Υ"],
    ["Ὺ","Υ"],["Ύ","Υ"],["Ῥ","Ρ"],["῭",""],["΅",""],
    ["`",""],["ῲ","ω"],["ῳ","ω"],["ῴ","ω"],["ῶ","ω"],
    ["ῷ","ω"],["Ὸ","Ο"],["Ό","Ο"],["Ὼ","Ω"],["Ώ","Ω"],
    ["ῼ","Ω"]
];

export function customUnidecode(str) {
    str = String(str).normalize('NFC');
    for (let [source, replacement] of unidecodeSymbols) {
        // split/join, not replace: a string needle replaces only the first hit,
        // so "vōcēs ōra" kept its second macron.
        str = str.split(source.normalize('NFC')).join(replacement);
    }
    return str;
}

function makeBag(str) {
    str = customUnidecode(str);
    return str.split(/[^\p{L}\d]+/u).filter(Boolean);
}

function compareWordBags(attemptBag, solutionBag) {
    const normalizedAttempt = attemptBag.map(word => word.toLowerCase().normalize('NFC'));
    const normalizedSolution = solutionBag.map(word => word.toLowerCase().normalize('NFC'));
    const solutionFlags = Array(normalizedSolution.length).fill(false);

    normalizedAttempt.forEach(word => {
        const index = normalizedSolution.findIndex((solWord, j) => solWord === word && !solutionFlags[j]);
        if (index !== -1) {
            solutionFlags[index] = true;
        }
    });

    const correctCount = solutionFlags.filter(flag => flag).length;
    const totalCount = Math.max(normalizedAttempt.length, normalizedSolution.length);
    const correctness = totalCount === 0 ? 0 : (correctCount / totalCount);
    const exactMatch = correctCount === normalizedSolution.length && normalizedAttempt.length === normalizedSolution.length;
    return { correctCount, totalCount, correctness, exactMatch };
}

function removeClassesByPrefix(element, prefix) {
    const classes = [...element.classList];

    classes.forEach(className => {
        if (className.startsWith(prefix)) {
            element.classList.remove(className);
        }
    });
}

export function launchConfetti() {
    const container = document.createElement('div');
    container.setAttribute('aria-hidden', 'true');
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.right = '0';
    container.style.bottom = '0';
    container.style.left = '0';
    container.style.pointerEvents = 'none';
    container.style.overflow = 'hidden';
    container.style.zIndex = '9999';

    const colors = ['#2563eb', '#7c3aed', '#10b981', '#f59e0b', '#ef4444', '#ec4899'];
    const pieces = 140;

    for (let i = 0; i < pieces; i += 1) {
        const piece = document.createElement('span');
        const size = 6 + Math.random() * 8;
        const left = Math.random() * 100;
        const delay = Math.random() * 0.15;
        const duration = 1.6 + Math.random() * 1.1;
        const drift = (Math.random() - 0.5) * 240;
        const rotation = 180 + Math.random() * 540;

        piece.style.position = 'absolute';
        piece.style.top = '-24px';
        piece.style.left = `${left}%`;
        piece.style.width = `${size}px`;
        piece.style.height = `${size * 0.6}px`;
        piece.style.backgroundColor = colors[i % colors.length];
        piece.style.opacity = '0.95';
        piece.style.borderRadius = Math.random() > 0.5 ? '999px' : '2px';
        piece.style.transform = `translate3d(0, 0, 0) rotate(0deg)`;
        piece.style.animation = `pantarhei-confetti-fall ${duration}s cubic-bezier(0.2, 0.8, 0.2, 1) ${delay}s forwards`;
        piece.style.setProperty('--pantarhei-confetti-drift', `${drift}px`);
        piece.style.setProperty('--pantarhei-confetti-rotation', `${rotation}deg`);
        container.appendChild(piece);
    }

    if (!document.getElementById('pantarhei-confetti-style')) {
        const style = document.createElement('style');
        style.id = 'pantarhei-confetti-style';
        style.textContent = `
@keyframes pantarhei-confetti-fall {
  0% { transform: translate3d(0, 0, 0) rotate(0deg); opacity: 0.95; }
  100% { transform: translate3d(var(--pantarhei-confetti-drift), 105vh, 0) rotate(var(--pantarhei-confetti-rotation)); opacity: 0; }
}`;
        document.head.appendChild(style);
    }

    (document.body || document.documentElement).appendChild(container);
    window.setTimeout(() => container.remove(), 3200);
}

// Score a bag-of-words answer against its authored solution(s): the best
// match among the alternatives, as exercises.js needs it for a deferred check.
export function scoreBagOfWords(textarea) {
    let solutionText = '';
    try {
        solutionText = decodeURIComponent(atob((textarea.dataset.solution || '').replace(/\s+/g, '')));
    } catch (_) {
        return { exactMatch: false, percentage: 0, solution: '' };
    }
    const attemptBag = makeBag(textarea.value);
    let best = { exactMatch: false, percentage: 0, solution: solutionText.split('||')[0] };
    solutionText.split('||').forEach((alt) => {
        const cmp = compareWordBags(attemptBag, makeBag(alt));
        const pct = Math.round(cmp.correctness * 100);
        if (cmp.exactMatch || pct > best.percentage) {
            best = { exactMatch: cmp.exactMatch, percentage: pct, solution: alt };
        }
    });
    return best;
}

export function initBagOfWords() {
    const solutions = {};
    const textareas = document.querySelectorAll('textarea.bagofwords,textarea.prosecomp');
    console.log('[bagofwords] init', { count: textareas.length });

    textareas.forEach((textarea, index) => {
        // In exam mode, data-solution is intentionally absent (answers stored server-side).
        // Skip solution-dependent setup; exam.js handles exam textareas independently.
        if (!textarea.hasAttribute('data-solution')) return;

        textarea.classList.add('form-control');
        // agenor.css supplies font-family and initial background for .bagofwords / .prosecomp.
        const statusDiv = document.createElement('div');
        statusDiv.className = 'bag-success';

        const progressDiv = document.createElement('div');
        progressDiv.className = 'bag-progress';
        progressDiv.setAttribute('role', 'progressbar');
        progressDiv.setAttribute('aria-valuemin', '0');
        progressDiv.setAttribute('aria-valuemax', '100');
        progressDiv.setAttribute('aria-valuenow', '0');

        const progressBarDiv = document.createElement('div');
        progressBarDiv.className = 'bag-progress-bar';
        progressDiv.appendChild(progressBarDiv);

        const progressTextDiv = document.createElement('div');
        progressTextDiv.className = 'bag-progress-text';

        statusDiv.appendChild(progressDiv);
        statusDiv.appendChild(progressTextDiv);
        textarea.after(statusDiv);

        textarea.dataset.solutionId = index;
        textarea.dataset.completed = 'false';
        try {
            solutions[index] = decodeURIComponent(atob(textarea.dataset.solution.replace(/\s+/g, '')));
        } catch (err) {
            // A malformed solution disables this field only, not the rest.
            console.error('[bagofwords] unreadable data-solution', { index, err });
            return;
        }

        textarea.addEventListener('input', function() {
            // Inside a deferred exercise nothing is scored while typing — only
            // the filled/empty tint, the check happens on «Prüfen».
            if (this.dataset.phDeferred === '1') {
                this.classList.remove('gap-input-correct');
                this.classList.toggle('gap-input-filled', this.value.trim().length > 0);
                return;
            }
            const id = this.dataset.solutionId;
            const solutionAlternatives = solutions[id].split('||');
            const attemptBag = makeBag(this.value);
            let correctness = 0;
            let exactMatch = false;
            let solution = solutionAlternatives[0];

            solutionAlternatives.forEach((altSolution) => {
                const solutionBag = makeBag(altSolution);
                const comparison = compareWordBags(attemptBag, solutionBag);
                if (comparison.correctness > correctness) {
                    correctness = comparison.correctness;
                    exactMatch = comparison.exactMatch;
                    solution = altSolution;
                } else if (comparison.correctness === correctness && comparison.exactMatch) {
                    exactMatch = true;
                }
            });

            if (correctness > 0) {
                console.log('[bagofwords] progress', { id, correctness });
                const percentage = Math.round(correctness * 100);
                progressDiv.setAttribute('aria-valuenow', String(percentage));
                progressBarDiv.style.width = `${percentage}%`;

                if (exactMatch) {
                    if (this.dataset.completed !== 'true') {
                        this.dataset.completed = 'true';
                        launchConfetti();
                    }
                    progressTextDiv.textContent = solution;
                } else {
                    this.dataset.completed = 'false';
                    progressTextDiv.textContent = `${percentage}%`;
                }
            } else {
                console.log('[bagofwords] cleared', { id });
                this.dataset.completed = 'false';
                progressDiv.setAttribute('aria-valuenow', '0');
                progressBarDiv.style.width = '0%';
                progressTextDiv.textContent = '';
            }

            // Background tint via CSS classes: red (default) → yellow (filled) → green (exact match)
            if (exactMatch) {
                this.classList.remove('gap-input-filled');
                this.classList.add('gap-input-correct');
            } else if (this.value.trim()) {
                this.classList.remove('gap-input-correct');
                this.classList.add('gap-input-filled');
            } else {
                this.classList.remove('gap-input-correct', 'gap-input-filled');
            }
        });
    });
}
